import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import loaderImage from "../../assets/icons/part-logo.png";
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Card from '../../components/cards/Card';
import { toast } from 'react-toastify';
import { getCenterAllotMedicines, getCenterMedicinesHistory, getCenters } from '../../services/clinic/centers';
import Dropdown from '../../components/inputFields/DropDown';
import { formatDateTime } from '../../utils/FormatDateTime';


function IssuedMedicines() {
    const [centers, setCenters] = useState([]);
    const [cardData, setCardData] = useState([
        // {
        //     title: "Total Medicines Issued",
        //     count: "--",
        // },
        // {
        //     title: "Total Medicines Sold",
        //     count: "--",
        // },
    ]);

    const [tableData, setTableData] = useState({});
    const [tableData2, setTableData2] = useState({});
    const [dropdownData, setDropdownData] = useState("Indore");
    const headers = [
        { label: "Issued Date", key: "created_at" },
        // { label: "Center", key: "center_name" },
        { label: "Medicine", key: "medicine_name" },
        { label: "Quantity", key: "quantity" },
    ];
    const headers2 = [
        { label: "Medicine", key: "medicine_name" },
        { label: "Stock Quantity", key: "quantity" },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [currentPage2, setCurrentPage2] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);

    const pageSize = 10;


    const fetchData = async (value) => {
        setLoading(true);
        try {
            let res = await getCenterAllotMedicines(value);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch medicines");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Medicines:", error);
        } finally {
            setLoading(false);
        }
    };

    const fetchData2 = async (value) => {
        setLoading2(true);
        try {
            let res = await getCenterMedicinesHistory(value);
            if (res.status === 200) {
                setTableData2(res.data);
            } else {
                toast.error("Unable to fetch medicines History");
            }
            setLoading2(false);
        } catch (error) {
            console.error("Error fetching Medicine History:", error);
        } finally {
            setLoading2(false);
        }
    };

    const fetchCenters = async () => {
        try {
            let res = await getCenters("?page_size=50");
            if (res.status === 200) {
                setCenters(res.data.results);
            } else {
                toast.error("Unable to fetch centers");
            }
        } catch (error) {
            console.error("Error fetching centers:", error);
        }
    };

    useEffect(() => {
        fetchCenters();
        fetchData("Indore");
        fetchData2("Indore");
    }, []);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePageChange2 = (page) => {
        setCurrentPage2(page);
    };

    const handleDropdownChange = (value) => {
        fetchData(value);
        fetchData2(value);
        setDropdownData(value);
    };

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/invoice' },
            { name: 'Issued Medicines' },
        ]} />
        <div className="py-3">
            <div className="flex flex-row items-center gap-4">
                <StyledHeadingText text={"Issued Medicines"} />
                <Dropdown
                    placeholder="Indore"
                    options={centers.map((center) => ({
                        value: center.name,
                        label: center.name,
                    }))}
                    needSearch
                    onChange={(value) => handleDropdownChange(value)}
                />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4 mt-2">
                {cardData.map((card, index) => (
                    <Card title={card.title} count={card.count} />
                ))}
            </div>
        </div>
        {
            dropdownData ?
                <>
                    {
                        <div className="mt-2 flex flex-col gap-6">
                            <div className="w-full flex-1">
                                <h3 className="text-md font-semibold mb-2 text-gray-700">Issued Medicines</h3>
                                {loading ?
                                    <div className="flex w-full flex-row justify-center my-2">
                                        <CustomLoading imageSrc={loaderImage} size={100} />
                                    </div>
                                    :
                                    <Table
                                        headers={headers}
                                        rows={tableData?.results?.map((item, index) => (
                                            {
                                                center_name: <p>{item.center_name}</p>,
                                                created_at: <p>{formatDateTime(item.created_at)}</p>,
                                                medicine_name: <p>{item.medicine_name}</p>,
                                                quantity: <p>{item.quantity_alloted}</p>,
                                            }))}
                                    />}
                                {tableData.count !== 0 ?
                                    <div className="xl:pl-5 pl-0 w-full flex-1">
                                        <Pagination
                                            currentPage={currentPage}
                                            totalPages={Math.ceil(tableData?.count / pageSize)}
                                            pageSize={pageSize}
                                            totalEntries={tableData?.count}
                                            onPageChange={handlePageChange}
                                            data={tableData}
                                            setTableData={setTableData}
                                        />
                                    </div> : <></>}
                            </div>
                            <div className="w-full flex-1">
                                <h3 className="text-md font-semibold mb-2 text-gray-700">Current Stock</h3>
                                {loading2 ?
                                    <div className="flex w-full flex-row justify-center my-2">
                                        <CustomLoading imageSrc={loaderImage} size={100} />
                                    </div>
                                    :
                                    <Table
                                        headers={headers2}
                                        rows={tableData2?.results?.map((item, index) => (
                                            {
                                                medicine_name: <p>{item.medicine_name}</p>,
                                                quantity: (
                                                    <div className="flex items-center gap-2">
                                                        <p className={item.stock_qt < 5 ? 'text-red-600 font-bold' : ''}>{item.stock_qt}</p>
                                                        {item.stock_qt < 5 && <span className="text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded-full font-semibold">Low Stock</span>}
                                                    </div>
                                                ),
                                            }))}
                                    />}
                                {tableData2.count !== 0 ?
                                    <div className="xl:pl-5 pl-0 w-full flex-1">
                                        <Pagination
                                            currentPage={currentPage2}
                                            totalPages={Math.ceil(tableData2?.count / pageSize)}
                                            pageSize={pageSize}
                                            totalEntries={tableData2?.count}
                                            onPageChange={handlePageChange2}
                                            data={tableData2}
                                            setTableData={setTableData2}
                                        />
                                    </div> : <></>}
                            </div>
                        </div>
                    }
                </> :
                <div className="flex flex-row py-10 w-full items-center justify-center bg-white rounded-md shadow-lg mx-2 mt-10 border-primary">
                    <StyledHeadingText text={"Select center to view data"} />
                </div>

        }
    </>);
}

export default IssuedMedicines;